module.exports = __webpack_public_path__ + "media/widget/DefferedGoals-0b0184c4.png";